<template>
  <div id="app">
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {}
}

</script>

<style lang="scss">
  body {
    margin: 0;
    padding: 0;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    background-color: #f7f7f7;
  }

  #app {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }

  .el-submenu [class^=fa] {
    vertical-align: baseline;
    margin-right: 10px;
  }

  .el-menu-item [class^=fa] {
    vertical-align: baseline;
    margin-right: 10px;
  }

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;

    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all .2s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
  /*滚动条美化*/
  ::-webkit-scrollbar-track-piece { //滚动条凹槽的颜色，还可以设置边框属性
    background-color:#f7f7f7;
  }
  ::-webkit-scrollbar {//滚动条的宽度
    width:10px;
    height:10px;
  }
  ::-webkit-scrollbar-thumb {//滚动条的设置
    background-color: #ccc;
    border-radius: 10px;
    background-clip:padding-box;
    min-height:28px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color:#bbb;
  }

  //.form-line /deep/ .el-form--inline .el-form-item {
  //  margin-right: 14px;
  //}
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    font-size: 12px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  .reportForm-dialog {
    border-top: 1px solid #409EFF;
    border-left: 1px solid #409EFF;
  }

  .reportForm-dialog .el-col {
    border-bottom: 1px solid #409EFF;
    border-right: 1px solid #409EFF;
    overflow: hidden;
  }
  .reportForm-dialog .el-form-item__label {
    width: 100%;
    height: 40px;
    text-align: center;
    background: rgba(64,158,255,0.1);
    border-right: 1px solid #409EFF;
    padding: 0;
  }
  .reportForm-dialog .el-form-item {
    margin: 0;
  }
  .reportForm-dialog .el-input__inner, .reportForm-dialog .el-textarea__inner {
    box-sizing: border-box;
    border: none;
    border-radius: 0;
  }
  /*上传*/
  .reportForm-dialog .el-upload__tip {
    margin-top: 0;
  }
  .reportForm-dialog .upload-demo {
    padding: 10px;
  }
  .reportForm-dialog .el-upload {
    padding-top: 7px;
  }
  .reportForm-dialog .el-form-item-detail {
    padding: 5px 10px;
    line-height: 30px;
    min-height: 40px;
    box-sizing: border-box;
  }
  .reportForm-dialog .form-label-top .el-form-item-detail {
    min-height: 70px;
    overflow: hidden;
  }
  .reportForm-dialog .form-label-top .el-form-item-detail-img {
    width: 31%;
    float: left;
    margin: 1%
  }
  .reportForm-dialog .el-form-item-lg {
    position: relative;
  }
  .reportForm-dialog .el-form-item-lg .el-form-item__label {
    line-height: 20px;
    min-height: 200px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
  }
  .reportForm-dialog .el-form-item-xl {
    position: relative;
  }
  .reportForm-dialog .el-form-item-xl .el-form-item__label {
    line-height: 20px;
    min-height: 300px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
  }
  .reportForm-dialog .el-form-item-md {
    position: relative;
  }
  .reportForm-dialog .el-form-item-md .el-form-item__label {
    line-height: 20px;
    min-height: 100px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
  }
  .el-form-item-add {
    position: absolute;
    right: 20px;
    bottom: 10px;
    z-index: 100;
    text-align: right;
    line-height: 30px;
  }
  .el-textarea .el-textarea__inner{
    resize: none;
    font-family: '微软雅黑';
  }
  /*public*/
  .flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  /*弹窗样式调整*/
  .el-dialog {
    position: relative;
    border-radius: 6px!important;
    overflow: hidden;
    border: 2px solid #409EFF;
  }
  .el-dialog__body {
    padding: 20px!important;
  }
  .el-dialog__title {
    position: relative;
    font-weight: bold;
    color: #fff!important;
  }
  .el-dialog__header {
    border-bottom: 1px solid #ddd;
    padding-bottom: 16px!important;
    background-color: #409EFF;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff!important;
    font-size: 20px;
  }
  /*手风琴样式调整*/
  .el-collapse-item__header {
    font-size: 14px!important;
    font-weight: bold!important;
  }
</style>
